import React, { useRef, useEffect, useContext, useState } from "react";
import { camelCase, find, get } from "lodash";
import {
  Image,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
  Toast,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import {
  ROUTES,
  usCurrency,
  getPathWithParam,
  MANAGE_PAYROLL_ROUTES,
  usDateFormat,
} from "../../../utils";
import {
  setManagePayrollToastInfo,
  managePayrollStore,
} from "../../../contexts";
import {
  AddToolTip,
  ExcelDropDown,
  LoaderWrapper,
  SliderPanel,
} from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
// import PayrollAndCensus from "../../../mocks/payrollAndCensusData.json";
import {
  deleteCensusFileById,
  getFileInformationWithErrorDetailsByFileId,
  getInputFileById,
  getPayrollCancellation,
  regenerateOutputFile,
} from "../../../services/";
import ContributionBreak from "./ContributionBreak";
import AllRecords from "./AllRecords";
import DataChange from "./DataChange";
import DataOverride from "./DataOverride";
import ErrorValidation from "./ErrorValidation";
import PayrollFunding from "./PayrollFunding";
import upload from "../../../styles/upload.png";
import sftp from "../../../styles/ftp.png";
import create from "../../../styles/create.png";
import authService from "../../../components/api-authorization/AuthorizeService";
import permissions from "../../../mocks/menuPermissions.json";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { trueFalseOptions } from "../../ReportsContainer/PeriodicCensus/columnMenu";

const PayrollReportsContainer = (props) => {
  const history = useHistory();
  const { payrollId } = useRouterParams();
  const intPayrollId = parseInt(payrollId, 10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isShow, setShow] = useState(false);
  const [isShowPopUp, setShowPopUp] = useState(false);
  const [open, setOpen] = useState(false);
  const showViewDetails = useRef(true);
  const subMenu = "cancelFile";
  const menu = "payroll";
  const { state: state2, dispatch } = useContext(managePayrollStore);
  const { showToast, toastMessage } = state2;
  const [isRegenerated, setRegenerated] = useState(false);
  const { response: payrollReports, loading: isLoading } = useRequest({
    method: getFileInformationWithErrorDetailsByFileId,
    payload: payrollId,
    defaultResponse: [],
  });
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  //to disable the view payroll details for census file
  useDeepEffect(() => {
    if (payrollReports?.fileType != 1) return;
    showViewDetails.current = false;
  }, [payrollReports?.fileType]);

  const showPopup = () => {
    setModalOpen(true);
  };

  const deleteCensusFile = (id) => {
    deleteCensusFileById(id)
      .then((response) => {
        if (response == true) {
          setShowPopUp(true);
        }
        if (response == false) {
          history.push(
            getPathWithParam({
              path: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
            })
          );
        }
      })
      .catch((error) => {
        throw error;
      });
  };
  const handleClick = (id) => {
    getPayrollCancellation(id).then((res) => {
      setOpen(!open);
      history.push(
        getPathWithParam({
          path: MANAGE_PAYROLL_ROUTES.UPLOADED_FILES_LISTING,
        })
      );
    });
  };
  const regenerateFile = () => {
    regenerateOutputFile({
      FileUploadId: payrollReports?.id,
      FileName: payrollReports?.fileName,
      ErrorMapId: payrollReports?.outputErrorMap,
    }).then((response) => {
      setRegenerated(true);
      if (response.isSuccess) {
        dispatch(
          setManagePayrollToastInfo({
            showToast: true,
            toastMessage: "Regenerated successfully",
          })
        );
      }
    });
  };

  return (
    <LoaderWrapper isLoading={isLoading}>
      <div className="payroll-report-container w-100">
        <div className="d-flex justify-content-between align-baseline">
          <div className="plan-heading-payroll font-weight-500">
            {payrollReports?.fileType == 2 ||
              (payrollReports?.fileType == 3 && "Payroll &")}
            {" Census Report"}
          </div>
          <div className="d-flex mt-10 mb-10">
            <Toast
              onClose={() =>
                dispatch(
                  setManagePayrollToastInfo({
                    showToast: false,
                    toastMessage: "",
                  })
                )
              }
              show={showToast}
              style={{
                position: "fixed",
                top: "10rem",
                right: "2rem",
                zIndex: "100",
              }}
              delay={3000}
              autohide
            >
              <Toast.Body className="success-toast-align">
                <div className="mr-2">
                  {showToast ? (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      color="#3BB54A"
                      size="lg"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div>{toastMessage}</div>
                <div className="ml-2">
                  {showToast ? (
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      color="#000000"
                      size="md"
                      onClick={() =>
                        dispatch(
                          setManagePayrollToastInfo({
                            showToast: false,
                            toastMessage: "",
                          })
                        )
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Toast.Body>
            </Toast>
            {payrollReports?.isError == true && (
              <Button
                type="button"
                variant={"primary"}
                style={{ paddingRight: "200px" }}
                onClick={regenerateFile}
                className="mr-3"
                disabled={isRegenerated}
              >
                Regenerate
              </Button>
            )}
            {permissions[roleName][menu + "SubMenu"][
              camelCase(subMenu)
            ]?.includes("D") &&
              (payrollReports?.fileType == 2 ||
              payrollReports?.fileType == 3 ? (
                <Button
                  type="button"
                  variant={"primary"}
                  // style={{ marginLeft: "1000px" }}
                  onClick={() => setOpen(!open)}
                >
                  Cancel File
                </Button>
              ) : (
                payrollReports?.fileType == 1 && (
                  <Button
                    onClick={() => setShow(true)}
                    variant="link"
                    style={{ marginLeft: "1000px" }}
                  >
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      color="#FF0000"
                      size="13px"
                    />
                  </Button>
                )
              ))}

            <div className="mt-7" style={{ marginLeft: "10px" }}>
              <Link to={ROUTES.PAYROLL}>
                <FontAwesomeIcon icon={faTimes} size="18px" color="#333333" />
              </Link>
            </div>
          </div>
        </div>
        <div className="border-top" />
        <div className="payroll-report">
          <Row>
            <Col md="3" className="brr-1">
              {/* <p className="black-text font-weight-500">
                {payrollReports.fileName}
              </p> */}
              <p className="mbbb-5">
                <Image
                  src={
                    payrollReports.uploadedThrough == "FileUpload"
                      ? upload
                      : payrollReports.uploadedThrough == "CreatePayroll"
                      ? create
                      : sftp
                  }
                />{" "}
                <span className="ft-12 black-text font-weight-500">
                  {payrollReports.fileName}
                </span>
              </p>
              <p className="grey-text ft-12">{payrollReports.paydate}</p>
              <p className="grey-text ft-12 mb-0">Plan name</p>

              {payrollReports?.planName?.length >= 40 ? (
                <AddToolTip name={payrollReports.planName}>
                  <p className="black-text ft-14 mbbb-5">
                    {(payrollReports.planName || "").slice(0, 15)}...
                  </p>
                </AddToolTip>
              ) : (
                <p className="black-text ft-14 mbbb-5">
                  {payrollReports.planName}
                </p>
              )}
              <p className="black-text ft-12 font-weight-500">
                <span className="grey-text ft-12 font-weight-300">
                  Plan ID :
                </span>{" "}
                {payrollReports.planId}
              </p>
              <p className="black-text ft-12 font-weight-500">
                <span className="grey-text ft-12 font-weight-300">
                  Plan group(s):
                </span>{" "}
                {payrollReports.planGroupNames &&
                payrollReports.planGroupNames.length > 40 ? (
                  <OverlayTrigger
                    overlay={<Tooltip>{payrollReports.planGroupNames}</Tooltip>}
                  >
                    <p className="black-text ft-12 font-weight-500">
                      {(payrollReports.planGroupNames || "").slice(0, 40)}...
                    </p>
                  </OverlayTrigger>
                ) : (
                  <p className="black-text ft-12 font-weight-500">
                    {payrollReports.planGroupNames}
                  </p>
                )}
              </p>

              <p className="grey-text ft-12 mb-0">Uploaded by</p>
              <p className="black-text ft-12 font-weight-500">
                {payrollReports.uploadedBy}
              </p>
              <p className="grey-text ft-12 mb-0">Status</p>
              <p className="black-text ft-12 font-weight-500">
                {payrollReports.fileStatus}
              </p>
            </Col>
            <Col md="9">
              <div className="d-flex justify-content-start">
                <div className="wd-20">
                  <p className="grey-text ft-12 mb-0">Plan ID</p>
                  <p className="ft-14 font-weight-500 black-text">
                    {payrollReports.planId}
                  </p>
                </div>
                <div className="wd-20">
                  <p className="grey-text ft-12 mb-0">Pay date</p>
                  <p className="ft-14 font-weight-500 black-text">
                    {payrollReports.payDate}
                  </p>
                </div>
                {payrollReports.fileType == 4 ? (
                  <>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Uploaded Date</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {usDateFormat(payrollReports.uploadedDate)}
                      </p>
                    </div>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Total records</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalRecords}
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Payroll</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.frequencyType}
                      </p>
                    </div>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Total Hours</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalHours?.toFixed(2)}
                      </p>
                    </div>
                    <div className="wd-20">
                      {showViewDetails.current ? (
                        <>
                          <p className="grey-text ft-12 mb-0">Total funding</p>
                          <p className="ft-18 font-weight-500 black-text mb-0">
                            {usCurrency(payrollReports.totalAmount)}
                          </p>

                          <p className="link-text" onClick={showPopup}>
                            View payroll details
                          </p>
                        </>
                      ) : null}
                    </div>
                  </>
                )}
                <div className="wd-20">
                  <p className="grey-text ft-12 mb-0">Download file</p>
                  <p>
                    <ExcelDropDown
                      submittedFile={"Submitted File"}
                      inputFile={"Input File (Before Error Correction)"}
                      fileName={payrollReports.fileName}
                      fileId={payrollId}
                      fileType={payrollReports.fileType}
                    />
                  </p>
                </div>
              </div>
              {payrollReports.fileType != 4 && (
                <>
                  <div className="d-flex justify-content-start">
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Total records</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalRecords}
                      </p>
                    </div>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Total errors</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalErrors}
                      </p>
                    </div>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">
                        Records with errors
                      </p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalErrorRecords}
                      </p>
                    </div>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Resolved errors</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalErrorsDetectedAndResolved}
                      </p>
                    </div>
                    <div className="wd-20">
                      <p className="grey-text ft-12 mb-0">Records deleted</p>
                      <p className="ft-14 font-weight-500 black-text">
                        {payrollReports.totalEmployeesDeleted}
                      </p>
                    </div>
                  </div>
                  <h4 className="view-text">View Reports</h4>
                  <div className="deposit_histoy_tabs">
                    <Tabs mountOnEnter unmountOnExit>
                      <Tab eventKey="all_records" title="All Records">
                        <AllRecords
                          payrollId={payrollId}
                          data={payrollReports}
                        />
                      </Tab>
                      <Tab eventKey="data_change" title="Data Change">
                        <DataChange
                          payrollId={payrollId}
                          data={payrollReports}
                        />
                      </Tab>
                      <Tab eventKey="data_override" title="Data Override">
                        <DataOverride
                          payrollId={payrollId}
                          data={payrollReports}
                        />
                      </Tab>
                      <Tab eventKey="error_validation" title="Error Validation">
                        <ErrorValidation
                          payrollId={payrollId}
                          data={payrollReports}
                        />
                      </Tab>
                      {/* <Tab eventKey="payroll_funding" title="Payroll Funding">
                            <PayrollFunding
                              payrollId={payrollId}
                              data={payrollReports}
                            />
                          </Tab> */}
                    </Tabs>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </div>
        <SliderPanel
          isOpen={isModalOpen}
          size="30"
          showCancel={false}
          backdropClicked={() => setModalOpen(false)}
        >
          <div className="d-flex justify-content-between">
            <div className="ft-14 font-weight-500">Payroll details</div>
            <div
              className="d-flex flex-row"
              onClick={() => setModalOpen(false)}
            >
              <Button className="payroll-close ml-2 pointer">Close</Button>
            </div>
          </div>
          <ContributionBreak payrollId={intPayrollId} />
        </SliderPanel>
      </div>
      <Modal show={open} size="smd">
        <Modal.Body>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#F94F50"
                size="3x"
                className="mt-3"
              />
            </div>
            <div className="remove-text">
              <p>
                You are attempting to cancel the file.Do you wish to continue?
              </p>
              <br />
              <Button
                variant="primary"
                style={{
                  backgroundColor: "#F94F50",
                  color: "white",
                  border: "2px solid #F94F50",
                }}
                onClick={() => handleClick(get(payrollReports, "id"))}
              >
                ok
              </Button>

              <Button
                variant="secondary"
                onClick={() => setOpen(!open)}
                className="ml-4 mr-3"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={isShow} size="smd">
        <Modal.Body>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#F94F50"
                size="3x"
                className="mt-3"
              />
            </div>
            <div className="remove-text">
              <p>Delete file?</p>
              <p>This file will be permanently deleted</p>
              <br />
              <Button
                variant="primary"
                style={{
                  backgroundColor: "#F94F50",
                  color: "white",
                  border: "2px solid #F94F50",
                }}
                onClick={() => {
                  setShow(false);
                  deleteCensusFile(payrollReports.id);
                }}
              >
                Delete
              </Button>

              <Button
                variant="secondary"
                onClick={() => setShow(false)}
                className="ml-4 mr-3"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={isShowPopUp} size="smd">
        <Modal.Body>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#F94F50"
                size="3x"
                className="mt-3"
              />
            </div>
            <div className="remove-text">
              <p>
                The file cannot be deleted, as there are census/payroll
                record(s) associated with the employee(s) in the file
              </p>
              <br />
              <Button
                variant="secondary"
                onClick={() => {
                  setShowPopUp(false);
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </LoaderWrapper>
  );
};

export default PayrollReportsContainer;
